module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fixed-nav', {
    staticClass: "fixed-side-bar-inside-fixed-top",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "heightOfNavInPixels": _vm.heightOfNavInPixels
    }
  }, [_c('div', {
    staticClass: "nav-slot",
    staticStyle: {
      "overflow-y": "hidden"
    },
    attrs: {
      "slot": "nav-slot"
    },
    slot: "nav-slot"
  }, [_vm._t("top-nav")], 2), _vm._v(" "), _c('fixed-side', {
    staticClass: "body-slot",
    style: ({
      'background-color': _vm.bodyBackgroundColor
    }),
    attrs: {
      "slot": "body-slot",
      "bodyID": _vm.bodyID,
      "sizeOfFixedSideInPixels": _vm.sizeOfFixedSideInPixels,
      "navBackgroundColor": _vm.nav_background_color
    },
    slot: "body-slot"
  }, [_c('div', {
    staticClass: "side-nav-slot",
    attrs: {
      "slot": "side-nav-slot"
    },
    slot: "side-nav-slot"
  }, [_vm._t("side-nav")], 2), _vm._v(" "), _c('div', {
    staticClass: "side-body-slot",
    staticStyle: {
      "position": "inherit"
    },
    attrs: {
      "slot": "side-body-slot"
    },
    slot: "side-body-slot"
  }, [_vm._t("body")], 2)]), _vm._v(" "), _vm._t("dialogs")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-b0d8d206!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/layouts/fixedSideBarInsideFixedTop/fixedSideBarInsideFixedTop.vue
// module id = 1663
// module chunks = 61